import { GetterTree } from 'vuex';
import { SitesState, SiteForDisplay } from './models';
import { RootState } from '@/store';

export enum Getters {
    SITES = 'SITES',
    FETCHED = 'FETCHED',
    SITE_FOR_DISPLAY = 'SITE_FOR_DISPLAY',
  }

export const getters: GetterTree<SitesState, RootState> = {
  [Getters.SITES]({ sitesForDisplay }): SiteForDisplay[] {
    return sitesForDisplay;
  },
  [Getters.FETCHED]({ isFetched }): boolean {
    return isFetched;
  },
  [Getters.SITE_FOR_DISPLAY]({ sitesForDisplay }) {
    return (code: string): SiteForDisplay | undefined => {
      const now = new Date();
      const sites: SiteForDisplay[] =
        sitesForDisplay.filter((s) => s.code.toUpperCase() === code.toUpperCase() &&
                                       ((!s.startDate && !s.endDate ) ||
                                        (s.startDate && new Date(s.startDate) < now && s.endDate && new Date(s.endDate) > now )));
      const result =  sites.length > 0 ? sites[0] : undefined;

      return result;
    };
  },

};
